<template>
  <div class="contact-us" style="position: relative;">
    <div class="contact-box Center" >
      <div class="contact-info Start">
        <div class="left-section">
          <img src="https://cyvideo.i-oranges.com/home/18.png" class="wid100">
        </div>

        <div class="center-section">
          <div class="title">
            <img src="https://cyvideo.i-oranges.com/home/6.png" class="wid100" alt="">
          </div>
          <div class="LeftBottom addBox">
            <div class="info">
              <p>成都国际城市设计产业中心B座9F-10F</p>
              <p>ichengyi@sina.com</p>
              <p>028-8454 0890</p>
              <p>www.i-orange.com.cn</p>
            </div>
            <div class="right-section">
              <div class="social-icons">
                <a href="javascript:;" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/weixin.png"   alt="微信"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/weixin.jpg" alt="">
                  </div>
                </a>
                <a href="javascript:;" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/icon/sp.png"   alt="视频号"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/shiping.jpg" alt="">
                  </div>
                </a>

                <a href="https://www.digitaling.com/company/13510" target="_blank" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/icon/sy.png" alt="数英网"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/shuy.jpg" alt="">
                  </div>
                </a>

                <a href="https://www.xiaohongshu.com/user/profile/608e25280000000001005679" target="_blank" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/icon/xhs.png" alt="小红书"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/xiaohongshu.jpg" alt="">
                  </div>
                </a>


                <a href="https://www.xinpianchang.com/u10672809?searchKw=%E6%A9%99%E6%84%8F%E6%9C%BA%E6%9E%84&from=search_post_creator" target="_blank" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/icon/new.png" alt="新片场"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/xinpc.jpg" alt="">
                  </div>
                </a>

                <a href="https://weibo.com/u/3737064350" target="_blank" style="position: relative" class="weixImg">
                  <img src="https://cyvideo.i-oranges.com/home/icon/weibo.png" alt="微博"/>
                  <div class="showWeiXin">
                    <img src="https://cyvideo.i-oranges.com/home/weibo.jpg" alt="">
                  </div>
                </a>

              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ContactUs',
};
</script>

<style scoped>
.showWeiXin{width: 150px; opacity: 0; transition: all 0.5s; height: 150px; position: absolute; top:-190px; left:-50px;}
.showWeiXin img{width: 100% !important; }
.contact-us {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #141414;
  color: #fff;

}
.weixImg:hover .showWeiXin{opacity: 1}
.contact-box{
  width: 76%;
  margin: auto auto 150px auto ;

}
.contact-info{width: 100%; height: 50%; margin-top: 6%;}
.contact-info .title{width: 24%;}

.left-section{width: 50%}
.left-section img{width: 79%}


.center-section {
  width: 50%;
}


.center-section p {
  font-size: 22px;
  color: #808080;
  line-height: 1.8;
  font-family: ali_R;
}
.center-section .info{ width: 100%; margin-top: 5%;}
.right-section {
  width: 55%;
  position: absolute; bottom: 5px;
  right: 4%;
}

.right-section img {
  width: 90px;
}
.addBox{width: 100%; position: relative; }

.social-icons {
width: 100%;
  margin-top: 126px;
  text-align: right;
  white-space: nowrap;
}

.social-icons a {
  margin-left: 10px;
}

.social-icons img {
  width: 48px;
  margin-left: 12px;

}


</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue